import { render, staticRenderFns } from "./WtThemeIcon.vue?vue&type=template&id=1389328d&scoped=true&"
import script from "./WtThemeIcon.vue?vue&type=script&lang=ts&"
export * from "./WtThemeIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WtThemeIcon.vue?vue&type=style&index=0&id=1389328d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389328d",
  null
  
)

export default component.exports